import { useMutation } from '@tanstack/react-query';
import { resetUserPassword } from "@/api/user"; 
import { ResetPasswordAdmin, ReturnResetPassword } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useResetUserPassword(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnResetPassword, Error, ResetPasswordAdmin>({
    mutationFn: resetUserPassword,
    onSuccess,
    onError
  });
}